import * as React from 'react';

export const  Css =()=> (
<svg version="1.0" viewBox="0 0 600 600" xmlns="http://www.w3.org/2000/svg">
 <g stroke-width=".7">
  <path d="m120 500-40-450h441l-40 450-181 50z" fill="#1572b6"/>
  <path d="m480 87h-180v425l146-40z" fill="#33a9dc"/>
  <path d="m378 193h-78v-55h138l-15 167h-124v-55h73z" fill="#fff"/>
  <path d="m235 333h-55l8 87 113 31 0.3-0.07v-57l-0.2 0.07-61-17z" fill="#ebebeb"/>
  <path d="m414 410 10-107h-55l-7 74-62 17v57l113-31z" fill="#fff"/>
  <path d="m300 193v0.1h-133l-4-40-1-15h138v34z" fill="#ebebeb"/>
  <path d="m300 305v0.1h-61l-4-40-1-15h66v34z" fill="#ebebeb"/>
 </g>
</svg>
)
